'use client';
import React from 'react';
import Link from 'next/link';

interface HistoryEmptyStateProps {
  hasSearch: boolean;
}

export default function HistoryEmptyState({ hasSearch }: HistoryEmptyStateProps) {
  return (
    <div className="bg-card rounded-3xl border border-border shadow-card p-16 flex flex-col items-center text-center">
      <div className="w-20 h-20 rounded-3xl gradient-primary-soft border border-border flex items-center justify-center mb-5">
        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" opacity="0.5">
          <circle cx="18" cy="18" r="16" stroke="var(--primary)" strokeWidth="2" />
          <circle cx="18" cy="18" r="7" stroke="var(--primary)" strokeWidth="2" />
          <path d="M18 10V4M18 32v-6M10 18H4M32 18h-6" stroke="var(--primary)" strokeWidth="2" strokeLinecap="round" />
        </svg>
      </div>
      {hasSearch ? (
        <>
          <h3 className="font-bold text-foreground" style={{ fontSize: '18px' }}>No QR codes match your search</h3>
          <p className="text-muted-foreground mt-2" style={{ fontSize: '14px', maxWidth: '320px' }}>
            Try adjusting your search query or clearing the type filter to see all your QR codes.
          </p>
        </>
      ) : (
        <>
          <h3 className="font-bold text-foreground" style={{ fontSize: '18px' }}>No QR codes generated yet</h3>
          <p className="text-muted-foreground mt-2" style={{ fontSize: '14px', maxWidth: '320px' }}>
            Your QR code history will appear here after you generate your first code. Each code is saved automatically.
          </p>
          <Link href="/" className="btn-primary mt-6 flex items-center gap-2" style={{ textDecoration: 'none', display: 'inline-flex' }}>
            <svg width="15" height="15" viewBox="0 0 15 15" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
              <path d="M7.5 2v11M2 7.5h11" />
            </svg>
            Generate Your First QR Code
          </Link>
        </>
      )}
    </div>
  );
}